'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIframeUuid = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIframeUuid = exports.getIframeUuid = (0, _get2.default)('iframeUuid');


//////////////////
// WEBPACK FOOTER
// ./js/iframeUuid/selectors/getIframeUuid.js
// module id = 810
// module chunks = 2 3